export {
  PropertyInsuranceModule,
  routepropertyinsurance,
  øPropertyInsuranceModule
} from './property-insurance.module';
export { StarterService } from './starter.service';

